import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g-contractor-list',
  templateUrl: './contractor-list.component.html',
  styleUrls: ['./contractor-list.component.scss']
})
export class ContractorListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
